import { isEmail, isPhoneNumber } from '@onefootprint/core';
import type { BootstrapDataV1, ModernRawBusinessDataRequest, VaultData } from '@onefootprint/request-types';

export type ValidatedIdentifyBootstrap = {
  data: BootstrapDataV1;
  bootstrapEmail?: string;
  bootstrapPhone?: string;
  isBootstrap: boolean;
};

const validateString = (value: unknown, validator: (v: string) => boolean): string | undefined =>
  typeof value === 'string' && validator(value) ? value : undefined;

/**
 * Builds the bootstrap data for identify session creation, plus prefill values for the email and
 * phone routes. Every KYC and KYB key goes through, because the backend vaults the session's
 * bootstrap at onboarding; an invalid email or phone is dropped.
 */
export function getValidatedIdentifyBootstrap(
  kycBootstrapData?: VaultData,
  kybBootstrapData?: ModernRawBusinessDataRequest,
): ValidatedIdentifyBootstrap {
  const bootstrapEmail = validateString(kycBootstrapData?.['id.email'], isEmail);
  const bootstrapPhone = validateString(kycBootstrapData?.['id.phone_number'], isPhoneNumber);
  const { 'id.email': _email, 'id.phone_number': _phone, ...otherKycData } = kycBootstrapData ?? {};

  const data: BootstrapDataV1 = {
    ...otherKycData,
    ...kybBootstrapData,
    ...(bootstrapEmail && { 'id.email': bootstrapEmail }),
    ...(bootstrapPhone && { 'id.phone_number': bootstrapPhone }),
  };

  return {
    data,
    bootstrapEmail,
    bootstrapPhone,
    isBootstrap: bootstrapEmail != null || bootstrapPhone != null,
  };
}
